import { render, staticRenderFns } from "./yuyueform.vue?vue&type=template&id=44920c4a&scoped=true"
import script from "./yuyueform.vue?vue&type=script&lang=js"
export * from "./yuyueform.vue?vue&type=script&lang=js"
import style0 from "./yuyueform.vue?vue&type=style&index=0&id=44920c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44920c4a",
  null
  
)

export default component.exports